import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '../../shared/components/ui/button/button.component';
import { BadgeComponent } from '../../shared/components/ui/badge/badge.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTableComponent, TableColumn } from '../../shared/components/tables/data-table/data-table.component';
import { ModalComponent } from '../../shared/components/ui/modal/modal.component';
import { RoleFormComponent } from './role-form/role-form.component';
import { AdminUsersService } from '../../core/services/admin-users.service';
import { AdminUser } from '../../core/models/admin.models';

interface UserRow {
  id: number;
  name: string;
  email: string;
  role: string;
  status: 'Active' | 'Inactive';
}

@Component({
  selector: 'app-role',
  standalone: true,
  imports: [
    CommonModule,
    DataTableComponent,
    ModalComponent,
    RoleFormComponent,
    ButtonComponent
  ],
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})
export class RoleComponent implements OnInit {
  @ViewChild('actionTemplate') actionTemplate!: TemplateRef<any>;
  
  columns: TableColumn[] = [];
  users: UserRow[] = [];
  isLoading = false;
  errorMessage = '';

  isModalOpen = false;
  selectedUser: UserRow | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private usersService: AdminUsersService
  ) {}

  ngOnInit() {
    this.loadUsers();
  }

  ngAfterViewInit() {
    this.columns = [
      { header: 'Name', field: 'name', type: 'string'},
      { header: 'Email', field: 'email', type: 'string'},
      { header: 'Role', field: 'role', type: 'string'},
      { header: 'Status', field: 'status', type: 'badge'},
      { header: 'Actions', field: 'actions', type: 'actions', cellTemplate: this.actionTemplate }
    ];
    this.cdr.detectChanges(); 
  }

  loadUsers(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.usersService.getUsers().subscribe({
      next: (res) => {
        const list: AdminUser[] = Array.isArray(res) ? res : (res as any).data ?? [];
        this.users = list.map(u => ({
          id: u.id,
          name: u.name,
          email: u.email,
          role: u.role,
          status: u.is_active ? 'Active' : 'Inactive'
        }));
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load users.';
        this.isLoading = false;
      }
    });
  }

  openEditModal(user: UserRow) {
    this.selectedUser = user;
    this.isModalOpen = true;
  }

  handleSave(data: any) {
    if (this.selectedUser) {
      this.usersService.updateUser(this.selectedUser.id, data).subscribe({
        next: () => {
          this.loadUsers();
          this.isModalOpen = false;
        },
        error: (err) => alert(err?.error?.message ?? 'Failed to update user.')
      });
    }
  }

  toggleBlock(user: UserRow) {
    const action$ = user.status === 'Active' 
      ? this.usersService.blockUser(user.id)
      : this.usersService.unblockUser(user.id);
      
    action$.subscribe({
      next: () => this.loadUsers(),
      error: (err) => alert(err?.error?.message ?? 'Action failed.')
    });
  }
}

